import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=680f2868&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=680f2868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f2868",
  null
  
)

export default component.exports